/* ============
 * Mutation types for the reports module
 * ============
 *
 * The mutation types that are available
 * on the reports module.
 */
import keyMirror from 'key-mirror';

export default keyMirror({
  FETCH_ENROLLED_PATIENT_REPORT_LIST: null,
  FETCH_ENROLLED_PATIENT_REPORT_SUCCESS: null,
  FETCH_ENROLLED_PATIENT_REPORT_FAIL: null,

  FETCH_RESOLVED_PATIENT_REPORT_LIST:null,
  FETCH_RESOLVED_PATIENT_REPORT_SUCCESS:null,
  FETCH_RESOLVED_PATIENT_REPORT_FAIL:null,
  
  FETCH_SYMPTOMS_PATIENT_REPORT_LIST:null,
  FETCH_SYMPTOMS_PATIENT_REPORT_SUCCESS:null,
  FETCH_SYMPTOMS_PATIENT_REPORT_FAIL:null,
  
  FETCH_ALL_PATIENT_REPORT_LIST:null,
  FETCH_ALL_PATIENT_REPORT_SUCCESS:null,
  FETCH_ALL_PATIENT_REPORT_FAIL:null,

  FETCH_PATIENTBYID_REPORT_LIST:null,
  FETCH_PATIENTBYID_REPORT_SUCCESS:null,
  FETCH_PATIENTBYID_REPORT_FAIL:null,
  
  FETCH_PATIENTBYID_WEEKLY_REPORT_LIST:null,
  FETCH_PATIENTBYID_WEEKLY_REPORT_SUCCESS:null,
  FETCH_PATIENTBYID_WEEKLY_REPORT_FAIL:null,

  FETCH_PATIENTBYID_YEARLY_REPORT_LIST:null,
  FETCH_PATIENTBYID_YEARLY_REPORT_SUCCESS:null,
  FETCH_PATIENTBYID_YEARLY_REPORT_FAIL:null

});
